import { TitleWrap, Title, Text } from '@/vdp/AlertModal';
import { useDDAddAction } from '~/hooks/common/telemetry';
import AlertIcon from './AlertIcon';

const VehicleUnavailable = () => {
  useDDAddAction('Vehicle Unavailable - Banner Shown');

  return (
    <>
      <TitleWrap>
        <AlertIcon />
        <Title>Vehicle Unavailable</Title>
      </TitleWrap>
      <Text>
        This vehicle is not available for purchase at this time. You can still
        take a look, as it may become available again in the future.
      </Text>
    </>
  );
};

export default VehicleUnavailable;
